import type { Day } from 'apiConnector/scheduledRun/model';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

interface DaysTriggerDisplayProps {
  days: readonly Day[];
  className?: string;
}
export function DaysTriggerDisplay({ days, className }: DaysTriggerDisplayProps) {
  return (
    <div className={classNames('text-uppercase', className)}>
      {days.map(day => (
        <span key={day} className="border border-1 px-1 me-1">
          <FormattedMessage id={`scheduledRun.days.${day}`} />
        </span>
      ))}
    </div>
  );
}
